import { Tag, Typography } from "antd";
import IntlMessages from "src/domain/utility/IntlMessages";
import { TreatmentDetailsDto } from "src/shared/services/patient/dto/treatment-details-dto";

/**
 * The tab endpoints return one flat row per order: a base treatment, or one of its
 * refinements/add-ons with `parentTreatmentId` set. This fills in the `isAdditional` and
 * `patientId` fields the columns use to link to (and delete) the right order.
 */
export const toTreatmentRows = (data: TreatmentDetailsDto[]): TreatmentDetailsDto[] =>
  data.map((row) =>
    row.parentTreatmentId
      ? { ...row, isAdditional: true, patientId: row.parentTreatmentId }
      : row,
  );

/** "Refinement #N" under the type of a refinement row, "Add-on" under a whitening/retainer one. */
export const AdditionalKindLabel = ({ record }: { record?: TreatmentDetailsDto }) => {
  if (!record?.parentTreatmentId) return null;
  return (
    <Typography.Text type="secondary" style={{ display: "block", fontSize: 12 }}>
      {record.refinementNumber ? (
        <IntlMessages
          id="treatment.refinementNumber"
          values={{ number: record.refinementNumber }}
        />
      ) : (
        <IntlMessages id="treatment.addOn" />
      )}
    </Typography.Text>
  );
};

/**
 * Marks a refinement the doctor submitted free under the base plan's refinement
 * allowance, so staff don't go looking for a payment that was never taken.
 */
export const CoveredByPlanTag = ({ record }: { record?: TreatmentDetailsDto }) =>
  record?.coveredByPlan ? (
    <div>
      <Tag color="green" style={{ marginTop: 4, marginInlineEnd: 0 }}>
        <IntlMessages id="treatment.coveredByPlan" />
      </Tag>
    </div>
  ) : null;
